// extracted by mini-css-extract-plugin
export default {"Rule":"Rule-module__Rule___2RgF_"};